const B_1 = [
    {
        title: '中标候选人',
        path: '/bidding/projectflow/dingbiao/zbhxr/list'
    }
]
export default {
    path: 'zbhxr',
    component: () => import(/*webpackChunkName: 'bidding-zbhxr'*/ '@layout/empty'),
    children: [
        {
            path:"list",
            component: () => import('@views/bidding/views/project-flow/ding/zbhxr/list'),
            meta: {
                title: '中标候选人列表',
                bread: B_1
            },
        },{
            path:"form",
            component: () => import(/*webpackChunkName: 'bidding-zbhxr'*/'@views/bidding/views/project-flow/ding/zbhxr/form'),
            meta: {
                title: '添加中标候选人',
                bread: [
                    ...B_1,
                    {
                        title: '添加中标候选人',
                        path: '/bidding/projectflow/dingbiao/zbhxr/form'
                    },
                ]
            },
        },{
            path:"detail",
            component: () => import(/*webpackChunkName: 'bidding-zbhxr'*/'@views/bidding/views/project-flow/ding/zbhxr/detail'),
            meta: {
                title: '中标候选人详情',
                bread: [
                    ...B_1,
                    {
                        title: '中标候选人详情',
                        path: '/bidding/projectflow/dingbiao/zbhxr/detail'
                    },
                ]
            },
        },
    ]
}